export default __webpack_public_path__ + "static/RootSans-14UltraItalic-864169d516c74923f22e30dbea38f75c.woff";